import { Component, OnInit, ViewChild } from '@angular/core';
import { UserTableDto } from 'src/app/entity/userTableDto';
import { MatTableDataSource } from '@angular/material/table';
import { Router, RouterLinkWithHref } from '@angular/router';
import { MatPaginator } from '@angular/material/paginator';
import { MatSort } from '@angular/material/sort';
import { UserService } from 'src/app/user/user.service';
import { MatDialog } from '@angular/material/dialog';
import { UserDetailViewComponent } from 'src/app/user/user-detail-view/user-detail-view.component';
import { User } from 'src/app/entity/user';
import { UserPasswordChangeComponent } from '../user-password-change/user-password-change.component';
import { ConfirmationDialogComponent } from 'src/app/shared/confirmation-dialog/confirmation-dialog.component';
import { SnackbarService } from 'src/app/snackbar/service/snackbar.service';
import { TranslateService } from '@ngx-translate/core';

@Component({
  selector: 'app-user-table-view',
  templateUrl: './user-table-view.component.html',
  styleUrls: ['./user-table-view.component.scss'],
})
export class UserTableViewComponent implements OnInit {
  users: MatTableDataSource<UserTableDto>;
  displayedColumns: string[] = [
    'surname',
    'name',
    'email',
    'role',
    'active',
    'edit',
    'password',
  ];

  @ViewChild(MatSort, { static: true }) sort: MatSort;
  constructor(
    private router: Router,
    private userService: UserService,
    public dialog: MatDialog,
    private snackService: SnackbarService,
    private translate: TranslateService
  ) {}

  ngOnInit(): void {
    this.users = new MatTableDataSource<UserTableDto>();
    this.getUsers();
  }

  getUsers(): void {
    this.userService.getUsers().subscribe((res) => {
      this.users.data = res;
      console.log(res);
    });

    if (this.users !== undefined) {
      this.users.sort = this.sort;
    }
  }

  showDetails(uuid: string): void {
    let user: User = null;

    this.userService.getUserById(uuid).subscribe((res) => {
      user = res;
      const dialogRef = this.dialog.open(UserDetailViewComponent, {
        data: user,
      });

      dialogRef.afterClosed().subscribe((result) => {
        this.getUsers();
      });
    });
  }

  createNewUser() {
    const newUser = new User();
    const dialogRef = this.dialog.open(UserDetailViewComponent, {
      data: newUser,
    });

    dialogRef.afterClosed().subscribe((result) => {
      this.getUsers();
    });
  }

  applyFilter(event: Event) {
    const filterValue = (event.target as HTMLInputElement).value;
    this.users.filter = filterValue.trim().toLowerCase();
  }

  changePassword(uuid: string): void {
    let user: User;

    this.userService.getUserById(uuid).subscribe((res) => {
      user = res;

      const dialogRef = this.dialog.open(UserPasswordChangeComponent, {
        width: '30%',
        data: user,
      });
    });
  }

  changeActivation(row: UserTableDto): void {
    let user: User;
    let confirmMessage: string;

    this.userService.getUserById(row.idGuid).subscribe((res) => {
      user = res;
      user.idGuid = row.idGuid;
      confirmMessage = this.translate.instant(
        user.active
          ? 'shared.confirmationDialog.deactivate'
          : 'shared.confirmationDialog.activate'
      );

      const dialogRef = this.dialog.open(ConfirmationDialogComponent, {
        width: '30%',
        data: confirmMessage,
      });

      dialogRef.afterClosed().subscribe((result) => {
        if (result) {
          this.userService.updateUser(user).subscribe(() => {
            this.snackService.open(
              'user.detail.snackbar.userEdited',
              4,
              'success'
            );
            this.getUsers();
          });
        } else {
          row.active = !row.active;
        }
      });
    });
  }
}
